import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {RadioButtonComponent} from "./radio-button.component";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";



@NgModule({
  declarations: [RadioButtonComponent],
  imports: [
    CommonModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatRadioButton,
    MatRadioGroup,
  ],
  exports: [
    RadioButtonComponent
  ]
})
export class RadioButtonModule {
}
